import { Injectable } from '@angular/core';

import { IBanner } from 'rev-portal/scheduledEvents/common/BannerTypes';

import { PushService } from 'rev-shared/push/PushService';

@Injectable({
	providedIn: 'root'
})
export class BannerService {

	constructor(
		private readonly PushService: PushService
	) { }

	public addBanner(webcastId: string, banner: IBanner): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:AddBanner', {
			webcastId,
			banner
		});
	}

	public updateBanner(webcastId: string, banner: IBanner): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:UpdateBanner', {
			webcastId,
			banner
		});
	}

	public deleteBanner(webcastId: string, bannerId: string): Promise<any> {
		return this.PushService.dispatchCommand('scheduledEvents:DeleteBanner', {
			webcastId,
			bannerId
		});
	}

}
